import React, { useState, useRef } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import semver from 'semver'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Loader, NotAllowed } from '../index'
import { useIframePageStyles } from './styles'
import { useObserver } from '~/core/utils/hooks'
import { useI18n } from '~/core/i18n'
import { useGlobalContext } from '~/core/context'

const IframePage = ({ src, links, title, ...props }) => {
  const [{ loading, isFrameAllowed }, setIframeState] = useState({
    loading: true,
    isFrameAllowed: true
  })
  const [msg, lang] = useI18n()
  const { pbx } = useGlobalContext()

  const iframeRef = useRef(null)
  const router = useRouter()
  const classes = useIframePageStyles()

  useObserver(loading, () => {
    const frameDocument = iframeRef.current.contentDocument
    if (!loading && frameDocument) {
      const isFrameAllowed = !frameDocument.querySelector('form > .spc')
      setIframeState(state => ({
        ...state,
        isFrameAllowed
      }))
    }
  })

  const handleIframeLoad = () =>
    setIframeState(state => ({
      ...state,
      loading: false
    }))

  return (
    <section className={classes.iframeWrapper} id="iframe-page" {...props}>
      {loading ? (
        <Loader />
      ) : (
        <nav className={classes.iframeNav}>
          {links.length
            ? links
                .filter(({ version }) => (version ? semver.satisfies(pbx.version, version) : true))
                .map(({ title, path, disabled }) => (
                  <Link key={path} as={path} href={router.pathname}>
                    <a
                      className={classnames(classes.iframeLink, {
                        active: router.asPath === path,
                        disabled: disabled === true
                      })}
                    >
                      {msg(title)}
                    </a>
                  </Link>
                ))
            : msg(title) && <a className={classnames(classes.iframeLink, 'active')}>{msg(title)}</a>}
        </nav>
      )}
      <div className={classes.iframeContent}>
        {isFrameAllowed ? (
          <iframe
            ref={iframeRef}
            className={classes.iframe}
            scrolling="auto"
            seamless
            src={src + `&lang=${lang === 'cz' ? 'cs' : 'en'}`}
            style={{
              display: loading ? 'none' : 'block'
            }}
            onLoad={handleIframeLoad}
          />
        ) : (
          <NotAllowed />
        )}
      </div>
    </section>
  )
}

IframePage.propTypes = {
  src: PropTypes.string.isRequired,
  links: PropTypes.array,
  title: PropTypes.string
}

IframePage.defaultProps = {
  links: []
}

export default IframePage
